export default __webpack_public_path__ + "static/media/icon.efd32fe4.png";